import { render, staticRenderFns } from "./CloneModeSelectionModal.vue?vue&type=template&id=354c0ff9&scoped=true"
import script from "./CloneModeSelectionModal.vue?vue&type=script&lang=js"
export * from "./CloneModeSelectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c0ff9",
  null
  
)

export default component.exports